module.exports = __webpack_public_path__ + "img/qrcode-750.30532704.png";